import script from "./UserScopeChips.vue?vue&type=script&setup=true&lang=js"
export * from "./UserScopeChips.vue?vue&type=script&setup=true&lang=js"

import "./UserScopeChips.vue?vue&type=style&index=0&id=4be926a4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be926a4"]])

export default __exports__